import React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { LineHeaderLabelKind } from './resolveLineHeaderLabel';

interface PropsType {
    kind: LineHeaderLabelKind;
}

export const LineHeaderLabel = ({ kind }: PropsType): JSX.Element => {
    switch (kind) {
        case 'corners':
            return (
                <I18n
                    langKey='events.match-corners-market.corners'
                    defaultText='Corners'
                />
            );
        case 'field-goals':
            return (
                <I18n
                    langKey='events.line-grouped-market.field-goals'
                    defaultText='Field Goals'
                />
            );
        case 'touchdowns':
            return (
                <I18n
                    langKey='events.line-grouped-market.touchdowns'
                    defaultText='Touchdowns'
                />
            );
        case 'sets':
            return (
                <I18n
                    langKey='events.line-grouped-market.sets'
                    defaultText='Sets'
                />
            );
        case 'runs':
            return (
                <I18n
                    langKey='events.line-grouped-market.runs'
                    defaultText='Runs'
                />
            );
        case 'points':
            return (
                <I18n
                    langKey='events.line-grouped-market.points'
                    defaultText='Points'
                />
            );
        case 'yards':
            return (
                <I18n
                    langKey='events.line-grouped-market.yards'
                    defaultText='Yards'
                />
            );
        case 'cards':
            return (
                <I18n
                    langKey='events.line-grouped-market.cards'
                    defaultText='Cards'
                />
            );
        case 'goals':
            return (
                <I18n
                    langKey='events.total-goals-market.goals'
                    defaultText='Goals'
                />
            );
    }
};
